<template>
    <div id="app">
        <global-notice/>
        <!-- <global-scan/> -->
        <global-audio/>
        <global-downloader/>
        <div style="z-index: 99999; width: 100%; height: 100%; position: fixed;"
             v-if="loadingStatus.loading"
             v-loading="loadingStatus.loading"
             v-loading.fullscreen.lock="true"
             :element-loading-text="loadingStatus.message"
             :element-loading-spinner="loadingStatus.spinner"
             :element-loading-background="loadingStatus.background"></div>
        <router-view v-if="isRouterAlive"></router-view>
        <el-dialog
                :visible.sync="newUrlDialog.show"
                append-to-body
                width="70%" class="messageDialog">
            <div style="text-align: center">
                <h1><b>📢工厂系统服务线路切换通告</b></h1><br/>
            </div>
            <div style="text-align: center">
                <p style="font-size: 16px;"> 旧线路 <b>{{newUrlDialog.oldUrl}}</b> 将于2025年6月15号全面停用。</p>
                <br/>
                <a :href="newUrlDialog.newUrl" style="color: green;font-size: 24px">
                    请点击切换 <span style="font-size: 16px;border-radius: 7px;color: white;background:#db2536;">新</span>
                    高速线路1：{{newUrlDialog.newUrl}}&nbsp;&nbsp;
                </a>
                <span style="color: #555;font-size: 16px;"><br/>进入新线路后，按'Ctrl+D键'收藏保存，已方便工作。</span>
                <br/><br/>
                <br/><br/>
                <br/><br/>
                <br/><br/>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import GlobalNotice from "@/components/global/GlobalNotice";
    // import GlobalScan from "@/components/global/GlobalScan";
    import GlobalAudio from "@/components/global/GlobalAudio";
    import GlobalDownloader from "@/components/global/GlobalDownloader";
    import { mapGetters } from 'vuex'
    import {notification} from "@/utils/NoticeUtil";

    export default {
        name: 'App',
        components: { GlobalNotice, GlobalAudio, GlobalDownloader },
        computed: {
            ...mapGetters([
                'loadingStatus'
            ])
        },
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                isRouterAlive: true,
                newUrlDialog:{
                    show:false,
                    oldUrl:"https://mobile.baielink.com",
                    matchOld:"mobile.baielink.com",
                    // matchOld:"localhost",
                    newUrl:"https://www.baielink.com"
                },
            }
        },
        mounted() {
            // 使用new URL()
            const url = new URL(window.location.href);
            if (url.origin.includes(this.newUrlDialog.matchOld))
                this.newUrlDialog.show = true
        },
        methods: {
            /*
             * 功能：重新加载当前页
             * Author：潘溢林
             */
            reload() {
                notification({ title: '刷新页面中...' })
                this.isRouterAlive = false
                this.$nextTick(() => {
                    notification({ title: '刷新页面完成', type: 'success' })
                    this.isRouterAlive = true
                })
            }
        }
    }
</script>

<style>
    @import "style/common.scss";

    * {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    @media screen and (max-width: 750px) {
        .el-message-box {
            width: 80% !important;
        }
    }

    #app {
        width: 100%;
        height: 100%;
    }
</style>
